import { getJSON, postJSON, putJSON } from 'bv-fetch';
import { createApi } from '@reduxjs/toolkit/query/react';

const baseQuery = () => async ({
  url, method = 'GET', body, defaultResponse,
}) => {
  try {
    let result;
    if (method === 'POST') {
      result = await postJSON(url, body);
    } else if (method === 'PUT') {
      result = await putJSON(url, body);
    } else {
      result = await getJSON(url);
    }

    return { data: result };
  } catch (error) {
    return {
      data: defaultResponse || null,
      error: {
        status: error.status || 500,
        data: error.message || error,
      },
    };
  }
};

export const TAG_TYPES = {
  PERSONAL_DETAILS: 'personalDetails',
  TIME_OUT: 'timeOut',
  UNREAD_STATUS: 'UnreadStatus',
  DEPOSIT_LIMITS: 'depositLimits',
};

export const tagTypesArray = Object.values(TAG_TYPES);

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery(),
  tagTypesArray,
  endpoints: () => ({}),
});
